import { initialState } from "./state"

export default {
  updateOrderToAudit: (state, payload) => (state.orderToAudit = payload),
  updateOrderToView: (state, payload) => (state.orderToView = payload),
  updateIsViewOnly: (state, payload) => (state.isViewOnly = payload),
  updateIsEditingData: (state, payload) => (state.isEditingData = payload),
  updateIsEditingFinishedOrder: (state, payload) => (state.isEditingFinishedOrder = payload),
  updateCurrentStep: (state, payload) => (state.currentStep = payload),
  updateLoading: (state, payload) => (state.loading = payload),
  updateIndexStepsAlreadyVisited: (state, payload) =>
    (state.indexStepsAlreadyVisited = payload),
  updateCurrentSteps: (state, payload) => (state.currentSteps = payload),
  updateOrder: (state, payload) => {
    state.order = payload
    state.originalCustomerAddress = payload?.customer?.address
      ? JSON.parse(JSON.stringify(payload.customer.address))
      : null
  },
  restoreCustomerAddress: state => {
    if (state.isViewOnly || !state.originalCustomerAddress || !state.order?.customer) {
      return
    }
    state.order.customer.address = JSON.parse(JSON.stringify(state.originalCustomerAddress))
  },
  updateCustomerAddress: (state, payload) => {
    if (state.isViewOnly || !state.order?.customer?.address) {
      return
    }
    const allowedFields = ["postcode", "address", "number", "neighborhood", "city", "state", "complement"]
    const address = { ...state.order.customer.address }
    allowedFields.forEach(key => {
      if (Object.prototype.hasOwnProperty.call(payload, key)) {
        address[key] = payload[key]
      }
    })
    state.order.customer.address = address
  },
  updateClient: (state, payload) => {
    Object.keys(payload).forEach(key => (state.client[key] = payload[key]))
  },
  updateBiometry: (state, payload) => {
    Object.keys(payload).forEach(key => (state.biometry[key] = payload[key]))
  },
  updateProducts: (state, payload) => {
    Object.keys(payload).forEach(key => (state.products[key] = payload[key]))
  },
  updateBilling: (state, payload) => {
    Object.keys(payload).forEach(key => (state.billing[key] = payload[key]))
  },
  updateContract: (state, payload) => {
    Object.keys(payload).forEach(key => (state.contract[key] = payload[key]))
  },
  resetAudit: state => {
    const init_state = initialState()
    const keysToKeep = ['auditFlow']
    Object.keys(state).forEach(key => {
      if (!keysToKeep.includes(key)) {
        state[key] = init_state[key]
      }
    })
  },
  updateCoverage: (state, payload) => {
    Object.keys(payload).forEach(key => (state.coverage[key] = payload[key]))
  },
  updateCredit: (state, payload) => {
    Object.keys(payload).forEach(key => (state.credit[key] = payload[key]))
  },
  updateInstallation: (state, payload) => {
    Object.keys(payload).forEach(
      key => (state.installation[key] = payload[key])
    )
  },
  updateComplement: (state, payload) => {
    if (state.isViewOnly) {
      return
    }
    const address = state.order?.customer?.address
    if (!address?.complement?.[payload.index]) {
      return
    }
    address.complement = address.complement.map((complement, index) =>
      index === payload.index ? { ...complement, [payload.key]: payload.value } : complement
    )
  },
  updateBillingComplements: (state, payload) => {
    state.billing.complements[payload.index][payload.key] = payload.value
  },
  updatePrintOrder: (state, payload) => {
    state.showPrintOrder = payload
  },
  setOptionsStatusReasons: (state, payload) => {
    state.optionsStatusReasons = payload
  },
  setOptionsServicesStatus: (state, payload) => {
    state.optionsServicesStatus = payload
  },
  setReasonProduct: (state, payload) => {
    const indexProduct = state.products.findIndex(product => {
      return product.service_uuid === payload.productUuid
    })

    if (indexProduct < 0) {
      return
    }

    state.products[indexProduct].status_reason = payload.newReason
  },
  setIsRouteReady: (state, payload) => {
    state.isRouteReady = payload
  },
  setProducts: (state, payload) => {
    state.products = payload
  },
  updateCoverageDetail: (state, payload) => {
    state.coverageDetail = payload
  },
  updateProductBillingDiscount: (state, payload) => {
    state.productBillingDiscount = payload
  },
  updateHasChangeShippingMethod: (state, payload) => {
    state.hasChangeShippingMethod = payload
  },
  updateHasChangePaymentMethod: (state, payload) => {
    state.hasChangePaymentMethod = payload
  },
  updateCondominiumComplement: (state, payload) => {
    state.client.condominiumComplement[payload.key] = payload.value
  },
  setAuditFlow: (state, payload) => {
    state.auditFlow = payload
  },
  updateNotes: (state, payload) => {
    state.order.notes = payload
  },
  updateCommission: (state, payload) => {
    state.commission = payload
  },
}
